import { render } from "./forgotPass.vue?vue&type=template&id=3a32e953&scoped=true"
import script from "./forgotPass.vue?vue&type=script&lang=js"
export * from "./forgotPass.vue?vue&type=script&lang=js"

import "./forgotPass.vue?vue&type=style&index=0&id=3a32e953&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a32e953"]])

export default __exports__